export const WEBSITE_DOMAIN_URL = "souqh.ca/app";
